// eslint-disable no-throw-literal
(() => {
  // const minQtyCache = new Map();

  // async function fetchMinQuantity(handle) {
  //   if (minQtyCache.has(handle)) return minQtyCache.get(handle);
  //   const token = window.storefrontAccessToken;
  //   if (!token || !handle) return 1;
  //   try {
  //     const shopRoot = window.Shopify?.routes?.root || "/";
  //     const res = await fetch(`${shopRoot}api/2024-01/graphql.json`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "X-Shopify-Storefront-Access-Token": token,
  //       },
  //       body: JSON.stringify({
  //         query: `query ($h: String!) { product(handle: $h) { mf: metafield(namespace: "custom", key: "mindestabnahme") { value } } }`,
  //         variables: { h: handle },
  //       }),
  //     });
  //     const data = await res.json();
  //     const val = parseInt(data?.data?.product?.mf?.value, 10);
  //     const minQty = val > 1 ? val : 1;
  //     minQtyCache.set(handle, minQty);
  //     return minQty;
  //   } catch {
  //     return 1;
  //   }
  // }

  class BuyButton extends HTMLElement {
    constructor() {
      super();
      this.cartOpener = null;
      this.cartDrawer = null;
      this.buyButton = null;
      this.variantID = null;
      this.moduleClassification = null;
      this.queryID = null;
    }

    connectedCallback() {
      this.cartOpener = document.querySelector(".js-cart-drawer-opener");
      this.cartDrawer = document.querySelector("cart-drawer");
      this.buyButton = this.querySelector("button");
      this.variantID = this.getAttribute("data-variant-id");
      this.moduleClassification = this.getAttribute("data-module-classification");
      this.categories = this.getAttribute("data-item-categories");

      this.productTitle = this.getAttribute("data-product-title");
      this.productHandle = this.getAttribute("data-product-handle");
      this.productImage = this.getAttribute("data-product-image");
      this.minProductQty = this.getAttribute("min-quantity");      

      //const { hitTemplate } = window.ProductSearch;

      // Check for query ID from attribute or URL parameter
      this.queryID = this.getAttribute("data-queryid");
      if (!this.queryID) {
        const urlParams = new URLSearchParams(window.location.search);
        this.queryID = urlParams.get("queryID");
      }

      if (this.buyButton) {
        this.buyButton.addEventListener("click", async (e) => {
          e.preventDefault();
          const qty = await this.getQuantity();
          this.addToCart(qty);
        });
      }
      if (this.parentElement.querySelector("quantity-selector")) {
        this.parentElement.addEventListener("changeQuantity", (e) => {
          if (e.target === this.parentElement.querySelector("quantity-selector")) {
            this.handleQuantityUpdate(e.detail.state);
          }
        });
      }
    }

    handleQuantityUpdate(state) {
      if (!state.hasCorrectQuantity) {
        // eslint-disable-next-line no-undef
        showErrorBox(state.message, this.parentElement, "buy-button__error-box--show", "buy-button__error-box--remove");
        const box = this.querySelector(".box");
        requestAnimationFrame(() => {
          setTimeout(() => {
            box.classList.add("buy-button__error-box--remove");
            box.classList.remove("buy-button__error-box--show");
          }, 3000);
        });
      }
    }

    async getQuantity() {
      const qtySelector = this.parentElement.querySelector("quantity-selector");
      if (qtySelector) {
        return qtySelector.querySelector(".js-qty-input").value;
      }
      const minQtyAttr = this.getAttribute("min-quantity");
      const confirmed = this.hasAttribute("data-min-qty-confirmed");
      if (minQtyAttr !== null && (confirmed || parseInt(minQtyAttr, 10) > 1)) {
        return parseInt(minQtyAttr, 10);
      }
      // const handle = this.getAttribute("data-product-handle");
      // if (handle) {
      //   return fetchMinQuantity(handle);
      // }
      return 1;
    }

    async addToCart(qty) {
      const upsellEnabled = window.themeSettings?.enableUpsellPopup === true;
      const upsellPopup = upsellEnabled ? document.querySelector("#upsell-popup") : null;

      // Suppress cart drawer opening when popup will be shown
      let originalCartOpenerClick = null;
      if (upsellPopup) {
        originalCartOpenerClick = this.cartOpener.click;
        this.cartOpener.click = function() {};
      } else {
        this.cartOpener.click();
      }

      this.querySelector(".loading__spinner")?.classList?.remove("hidden");
      this.buyButton.setAttribute("aria-disabled", true);

      // Check if quantity was clamped
      const qtySelector = this.parentElement.querySelector("quantity-selector");
      const quantityWarning = qtySelector?.getAttribute("data-quantity-clamped") === "true";
      const maxQty = qtySelector ? parseInt(qtySelector.querySelector(".js-qty-input")?.getAttribute("max"), 10) : null;

      const variantId = parseInt(this.variantID, 10);
      const quantity = parseInt(qty, 10) || 1;

      if (!variantId || isNaN(variantId)) {
        console.error("BuyButton: Invalid variant ID", this.variantID);
        this.querySelector(".loading__spinner")?.classList.add("hidden");
        this.buyButton.setAttribute("aria-disabled", false);
        return;
      }

      const formData = {
        items: [
          {
            id: variantId,
            quantity: quantity,
            properties: {
              _moduleClassification: this.moduleClassification || "",
              _categories: this.categories || "",
            },
          },
        ],
      };

      // Track Algolia add to cart event
      if (window.aa) {
        const price = parseFloat(this.getAttribute("data-price") || "0");

        // Store minimal data needed for purchase tracking
        const selectedRecord = {
          index: window.algoliaConfig.indexName,
          objectIDs: [this.variantID],
          ...(this.queryID && { queryID: this.queryID }),
          currency: window.algoliaConfig.currency || "EUR",
        };

        // Send appropriate event to Algolia
        if (this.queryID) {
          window.aa("addedToCartObjectIDsAfterSearch", {
            ...selectedRecord,
            eventName: "Product Added To Cart",
            objectData: [
              {
                price,
                quantity: parseInt(qty, 10),
              },
            ],
          });
        } else {
          window.aa("addedToCartObjectIDs", {
            ...selectedRecord,
            eventName: "Product Added To Cart",
            objectData: [
              {
                price,
                quantity: parseInt(qty, 10),
              },
            ],
          });
        }

        // Store the minimal record for purchase tracking
        try {
          const PURCHASE_STORAGE_KEY = "algolia_analytics_purchase_objects";
          const purchaseStorage = localStorage.getItem(PURCHASE_STORAGE_KEY);
          const purchaseObjects = purchaseStorage ? JSON.parse(purchaseStorage) : [];
          purchaseObjects.push(selectedRecord);
          localStorage.setItem(PURCHASE_STORAGE_KEY, JSON.stringify(purchaseObjects));
        } catch (error) {
          console.error("Failed to store purchase event:", error);
        }
      }

      this.cartDrawer.addToCart(formData, quantityWarning, maxQty).finally(() => {
        this.querySelector(".loading__spinner")?.classList.add("hidden");
        this.buyButton.setAttribute("aria-disabled", false);

        // Restore original cartOpener.click
        if (originalCartOpenerClick) {
          this.cartOpener.click = originalCartOpenerClick;
        }

        // Show upsell popup if enabled
        if (upsellPopup) {
          this.openUpsellPopup();
        }
      });
    }

    // Opens Popup Code
    async openUpsellPopup() {
      const popup = document.querySelector("#upsell-popup");
      const backdrop = document.querySelector("#upsell-popup-backdrop");
      const mainBody = document.querySelector("body");
      const upsellMessage = window.themeSettings?.popupMessage;
      if (!popup) return;

      // Re-read attributes (may have been set after connectedCallback for Algolia cards)
      const productTitle = this.getAttribute("data-product-title") || this.productTitle || "";
      const productImage = this.getAttribute("data-product-image") || this.productImage || "";
      const productHandle = this.getAttribute("data-product-handle") || this.productHandle || "";
      const productId = this.getAttribute("product-id") || "";

      // Close function (reusable)
      const closePopup = () => {
        popup.classList.add("hide");
        backdrop?.classList.add("hide");
        mainBody.classList.remove("popup_active");
        document.removeEventListener("keydown", escHandler);
      };

      // ESC key closes popup
      const escHandler = (e) => {
        if (e.key === "Escape") closePopup();
      };

      // Show popup and backdrop
      popup.classList.remove("hide");
      backdrop?.classList.remove("hide");
      mainBody.classList.add("popup_active");

      // Close button
      popup.querySelector(".upsell-popup__close").onclick = closePopup;

      // Click outside (backdrop) closes popup
      if (backdrop) {
        backdrop.onclick = closePopup;
      }

      document.addEventListener("keydown", escHandler);

      // Load added product info
      const productBox = popup.querySelector(".upsell-popup__product");
      productBox.innerHTML = `
        <div class="added_product_info">
          ${productImage ? `<img src="${productImage}" alt="${productTitle}">` : ""}
          <div class="added_product_meta">
            <p>${upsellMessage || ""}</p>
            <span>${productTitle}</span>
          </div>
        </div>
      `;

      // Load add-on slider with error handling
      try {
        await this.loadAddonSlider(productHandle, productId);
      } catch (e) {
        console.error("Failed to load addon slider:", e);
      }
    }

    normalizeShopifyProduct(p) {
      const variant = p.variants?.[0];
      return {
        title: p.title,
        handle: p.handle,
        image: p.featured_image || p.images?.[0] || "",
        images: p.images || [],
        price: p.price / 100,
        compare_at_price: p.compare_at_price ? p.compare_at_price / 100 : null,
        vendor: p.vendor || "",
        objectID: (variant?.id || p.id).toString(),
        variantId: variant?.id || p.id,
        id: p.id,
        inventory_available: p.available !== false,
        tags: p.tags || [],
        variants: p.variants || [],
        meta: { custom: {} },
      };
    }

    async loadAddonSlider(handle, productId) {
      const popup = document.querySelector("#upsell-popup");
      const swiperWrapper = popup.querySelector(".swiper-wrapper");
      const emptyState = popup.querySelector(".upsell-popup__slider-empty");
      const sliderSection = popup.querySelector(".upsell-popup__slider");

      // Reset state
      swiperWrapper.innerHTML = "";
      emptyState?.classList.add("hide");

      let productList = null;
      let isShopifyData = false;

      // Try to get add-ons from DOM (available on PDP)
      const jsonEl = document.querySelector(`#addons-${handle}`);
      if (jsonEl) {
        try {
          productList = JSON.parse(jsonEl.textContent);
          isShopifyData = true;
        } catch (e) {
          console.error("Failed to parse addons JSON:", e);
        }
      }

      // If no local JSON, try to fetch via Section Rendering API
      if (!productList || productList.length === 0) {
        try {
          const response = await fetch(`/products/${handle}?sections=product-addons-json`);
          if (response.ok) {
            const data = await response.json();
            const html = data["product-addons-json"];
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const scriptEl = doc.querySelector("script[type='application/json']");
            if (scriptEl) {
              productList = JSON.parse(scriptEl.textContent);
              isShopifyData = true;
            }
          }
        } catch (e) {
          console.error("Failed to fetch addons via Section Rendering API:", e);
        }
      }

      // Shopify product JSON uses cents, hitTemplate expects euros
      if (isShopifyData && productList?.length > 0) {
        productList = productList.map(p => this.normalizeShopifyProduct(p));
      }

      // Fallback 1: If still no recommendations, try Shopify Product Recommendations
      if (!productList || productList.length === 0) {
        if (productId) {
          try {
            const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=6&intent=related`);
            if (response.ok) {
              const data = await response.json();
              if (data.products && data.products.length > 0) {
                productList = data.products.map(p => this.normalizeShopifyProduct(p));
              }
            }
          } catch (e) {
            console.error("Failed to fetch Shopify recommendations:", e);
          }
        }
      }

      // Fallback 2: Recently viewed products from cookie
      if (!productList || productList.length === 0) {
        try {
          const cookie = document.cookie.split("; ").find(row => row.startsWith("recentlyViewed"));
          if (cookie) {
            const recentHandles = JSON.parse(cookie.split("=")[1]);
            // Filter out current product and limit to 6
            const filteredHandles = (recentHandles || []).filter(h => h !== handle).slice(0, 6);
            if (filteredHandles.length > 0) {
              const slides = await Promise.all(
                filteredHandles.map(async (h) => {
                  try {
                    const resp = await fetch(`${window.Shopify.routes.root}products/${h}?section_id=last-viewed-product`);
                    const text = await resp.text();
                    const doc = new DOMParser().parseFromString(text, "text/html");
                    const slide = doc.querySelector(".js-product-slide");
                    if (slide && slide.querySelector(".product-card__title")?.textContent.trim()) {
                      return slide.outerHTML;
                    }
                  } catch (_) {}
                  return null;
                })
              );
              const validSlides = slides.filter(Boolean);
              if (validSlides.length > 0) {
                swiperWrapper.innerHTML = validSlides.join("");
                sliderSection?.querySelector("product-slider")?.classList.remove("hide");
                const productSlider = sliderSection?.querySelector("product-slider");
                if (productSlider && typeof productSlider.initSwiper === "function") {
                  productSlider.initSwiper();
                }
                return;
              }
            }
            //console.log("If Acceessories does not exist and recently view then productList", productList);
          }
        } catch (e) {
          console.error("Failed to load recently viewed products:", e);
        }
      }

      // Hide slider section entirely if nothing to show
      if (!productList || productList.length === 0) {
        sliderSection?.style.setProperty("display", "none");
        return;
      }

      // Ensure slider is visible
      sliderSection?.style.removeProperty("display");
      sliderSection?.querySelector("product-slider")?.classList.remove("hide");

      // Render recommendations
      const { hitTemplate } = window.ProductSearch || {};

      if (!hitTemplate) {
        console.error("ProductSearch.hitTemplate not available");
        emptyState?.classList.remove("hide");
        return;
      }

      productList.forEach((hit, index) => {
        const slide = document.createElement("div");
        slide.className = "swiper-slide";

        const hitHtml = hitTemplate(hit);

        slide.innerHTML = hitHtml;
        slide.index = index;      

        swiperWrapper.appendChild(slide);
      });

      // Initialize swiper only on desktop (>1028px) - on mobile, native scroll is used
      const swiperParent = sliderSection?.querySelector(".swiper");
      const isDesktop = window.matchMedia("(min-width: 1029px)").matches;
      if (swiperParent && typeof Swiper !== "undefined" && isDesktop) {
        const productSlider = sliderSection?.querySelector("product-slider");
        if (productSlider?.swiper) {
          productSlider.swiper.destroy(true, true);
          productSlider.swiper = null;
        }
        const nextBtn = sliderSection?.querySelector(".swiper-button-next");
        const prevBtn = sliderSection?.querySelector(".swiper-button-prev");
        if (window._upsellSwiper) {
          window._upsellSwiper.destroy(true, true);
        }
        window._upsellSwiper = new Swiper(swiperParent, {
          slidesPerView: 3,
          spaceBetween: 0,
          slidesPerGroup: 3,
          grabCursor: true,
          navigation: nextBtn && prevBtn ? { nextEl: nextBtn, prevEl: prevBtn } : undefined,
        });
      }
    }

  }

  customElements.define("buy-button", BuyButton);
})();
